export default __webpack_public_path__ + "static/MediaContentEight-547fc47a20d7d60f06ec393e03bff279.webp";